import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import media from '../../styles/config/mediaQueries';

const StyledContainer = styled.section`
  padding: 10px 0;

  .swiper-slide {
    min-height: 100%;
    height: unset;
    ${media.mobile`
      width: 187px;
    `}
    ${media.desktop`
      width: 200px;
    `}
  }
`;

const StyledVideoButton = styled.button`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 200px;
  padding: 21px 18px 42px;
  border-radius: 4px;
  background-image: linear-gradient(
      to right,
      ${rgba(theme.color.black, 0.5)},
      ${rgba(theme.color.black, 0.5)}
    ),
    url(${props => props.bgimage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
`;

const StyledSocial = styled.span`
  height: auto;
  width: auto;
  max-width: 67px;
  max-height: 27px;
  margin-bottom: 10px;
`;

const StyledTitle = styled.h3`
  ${typeStyle.h3}
  margin-top: auto;
  margin-bottom: 10px;
`;

const StyledLength = styled.span`
  opacity: 0.6;
  position: absolute;
  bottom: 15px;
  left: 18px;
`;

const StyledPlay = styled.span`
  position: absolute;
  right: 14px;
  bottom: 15px;
  width: 22px;
  height: 22px;
  background-color: ${theme.color.white};
  border-radius: 50%;

  svg {
    width: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-90deg);

    path {
      fill: ${theme.color.black};
    }
  }
`;

export { StyledContainer, StyledVideoButton, StyledSocial, StyledTitle, StyledLength, StyledPlay };
